import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_ORGANIZATIONS_LIST: {
    url: "organizations-list",
    method: "get",
  },
  GET_EXPORT_LIST: {
    url: "export",
    method: "get",
  },
  INSERT_EXPORT_LIST: {
    url: "export",
    method: "post",
  },
  DOWNLOAD_EXPORT: (documentId) => ({
    url: `document/${documentId}/export`,
    method: "get",
  }),
  POST_SCHOOLS_BY_COMMUNITY: {
    url: "schools-list",
    method: "post",
  },
  GET_SCHOOLS_BY_COMMUNITY: {
    url: "schools-list",
    method: "get",
  },

};

export const useOrganizationsList = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_ORGANIZATIONS_LIST);

export const useExportList = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_EXPORT_LIST);

export const useInsertExportList = () =>
  useApiFetcherSWR(API_ENDPOINT.INSERT_EXPORT_LIST);

export const useDownloadExport = (id) =>
  useApiFetcherSWR(
    id ? API_ENDPOINT.DOWNLOAD_EXPORT(id) : null
  );

export const useSchoolsByCommunity = () =>
  useApiFetcherSWR(API_ENDPOINT.POST_SCHOOLS_BY_COMMUNITY);

export const useSchoolsByCommunityId = (communityId) =>
  useApiFetcherSWR(
    communityId
      ? {
        ...API_ENDPOINT.GET_SCHOOLS_BY_COMMUNITY,
        url: `${API_ENDPOINT.GET_SCHOOLS_BY_COMMUNITY.url}?iCommunityId=${communityId}`,
      }
      : null
  );


// export const API_ENDPOINT = {
//   GET_SCHOOLS_BY_COMMUNITY: {
//     url: "schools-list",
//     method: "get",
//   },
// };


